// export const API_ROOT = 'http://localhost:8555'
// export const API_ROOT = 'http://10.0.0.20:8555'
// export const API_ROOT = 'http://10.0.0.36:8555'
export const SOCKET_API = 'wss://api.zizbeyjobs.com'
export const API_ROOT = 'https://api.zizbeyjobs.com'
export const IS_DESKTOP_APP = false
  